import { useState } from "react";

const testimonials = [
  {
    quote: "I've stored my 1967 Mustang Fastback at Don Collins for three winters now. The facility is spotless, the alarmed indoor environment is exactly what a collector needs, and Don's team has always been responsive. No moisture issues, no surprises — just peace of mind.",
    name: "Robert M.",
    title: "Classic Car Collector, San Rafael",
    rating: 5,
  },
  {
    quote: "I needed a secure indoor space for my BMW R90S during a 6-month work trip. Don Collins was professional, affordable, and the motorcycle was in perfect condition when I returned. The private indoor access setup is ideal for high-value bikes.",
    name: "James T.",
    title: "Motorcycle Enthusiast, Marin County",
    rating: 5,
  },
  {
    quote: "We've used Don Collins for our seasonal RV storage for years. The Point Richmond location is incredibly convenient, the facility is always clean, and the rate for long-term storage is very reasonable. Highly recommend for anyone in the East Bay.",
    name: "Patricia &amp; Gary L.",
    title: "RV Owners, Oakland",
    rating: 5,
  },
  {
    quote: "My Porsche 911 sits in their San Rafael facility every winter. The fully alarmed indoor storage gives me complete confidence. Don has forgotten more about automotive care than most people ever learn. Exceptional service.",
    name: "Michael H.",
    title: "Porsche Collector, Corte Madera",
    rating: 5,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const current = testimonials[active];

  return (
    <section className="bg-[#0D0D0D] py-24 lg:py-32">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            Client Stories
          </p>
          <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold">
            Trusted by Collectors
          </h2>
        </div>

        {/* Main Card */}
        <div className="bg-charcoal-200 rounded-2xl p-10 lg:p-14 border border-white/5 mb-8">
          {/* Quote mark */}
          <div className="font-serif text-gold/30 text-8xl leading-none mb-4 select-none">&ldquo;</div>

          <blockquote className="font-serif text-white text-xl lg:text-2xl italic leading-relaxed mb-10">
            <span dangerouslySetInnerHTML={{ __html: current.quote }} />
          </blockquote>

          <div className="flex items-center justify-between flex-wrap gap-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0">
                <span className="font-serif text-gold text-lg font-bold">
                  {current.name.charAt(0)}
                </span>
              </div>
              <div>
                <p
                  className="font-sans text-white font-medium text-sm"
                  dangerouslySetInnerHTML={{ __html: current.name }}
                />
                <p className="font-sans text-[#9A9A9A] text-xs mt-0.5">{current.title}</p>
              </div>
            </div>
            {/* Stars */}
            <div className="flex items-center gap-1">
              {Array.from({ length: current.rating }).map((_, i) => (
                <div key={i} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-gold text-sm"></i>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex items-center justify-center gap-3">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setActive(idx)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                idx === active
                  ? "w-6 h-3 bg-gold"
                  : "w-3 h-3 bg-white/20 hover:bg-white/40"
              }`}
              aria-label={`Testimonial ${idx + 1}`}
            />
          ))}
        </div>

        {/* Prev/Next */}
        <div className="flex items-center justify-center gap-4 mt-6">
          <button
            onClick={() => setActive((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
            className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white hover:border-gold hover:text-gold transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            onClick={() => setActive((prev) => (prev + 1) % testimonials.length)}
            className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white hover:border-gold hover:text-gold transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
